export const usageLink = {
    href: '/app/settings/billing',
    icon: { selected: 'miscWallet', unselected: 'miscWallet' },
    text: 'Usage',
};
export const moveZapsLink = {
    href: '/app/move-zaps/',
    icon: { selected: 'arrowBigRight', unselected: 'arrowBigRight' },
    text: 'Move Zaps',
};
export const settingsLink = {
    href: '/app/settings/profile',
    icon: { selected: 'navCog', unselected: 'navCog' },
    text: 'Settings',
};
export const logOutLink = {
    href: '/logout',
    icon: 'arrowExit',
    text: 'Log Out',
};
export const AccountsMenuLinks = [
    settingsLink,
    logOutLink,
];
export const topNavFallbackData = {
    topBarMenu: [
        {
            text: 'Solutions',
            href: null,
            submenu: [
                {
                    text: 'By role',
                    href: null,
                    icon: { selected: 'personOne', unselected: 'personOne' },
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/solutions/marketing',
                        },
                        {
                            text: 'Business owners',
                            href: '/solutions/business-owner',
                        },
                        {
                            text: 'IT',
                            href: '/solutions/it',
                        },
                        {
                            text: 'Sales operations',
                            href: '/solutions/sales',
                        },
                    ],
                },
                {
                    text: 'By workflow',
                    href: null,
                    icon: { selected: 'navBriefcase', unselected: 'navBriefcase' },
                    submenu: [
                        {
                            text: 'Lead management',
                            href: '/solutions/lead-management',
                        },
                        {
                            text: 'Customer communications',
                            href: '/solutions/customer-communication',
                        },
                        {
                            text: 'Internal processes',
                            href: '/solutions/internal-processes',
                        },
                        {
                            text: 'Data management',
                            href: '/solutions/data-management',
                        },
                    ],
                },
                {
                    text: 'By company size',
                    href: null,
                    icon: { selected: 'navExplore', unselected: 'navExplore' },
                    submenu: [
                        {
                            text: 'Startups',
                            href: '/solutions/startups',
                        },
                        {
                            text: 'Small & medium businesses',
                            href: '/solutions/smb',
                        },
                        {
                            text: 'Enterprise',
                            href: '/solutions/enterprise',
                        },
                    ],
                },
            ],
            bottomLinks: [
                {
                    text: 'Contact Sales',
                    icon: { selected: 'actionCalendar', unselected: 'actionCalendar' },
                    href: '/l/contact-sales?demo_source=cs_nav_menu_solutions',
                },
                {
                    text: 'Explore app integrations',
                    icon: { selected: 'actionExplore', unselected: 'actionExplore' },
                    href: '/apps',
                },
                {
                    text: 'Access AI features',
                    icon: 'miscAI',
                    href: '/ai',
                },
            ],
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Streamline team comms',
                    href: '/customer-stories/calendly',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/20cbb6de7db26e259a378a859c8ea53b.png',
                    description: "How automation saves Calendly's team 10+ hours a week",
                    altText: "Calendly's logo.",
                },
                {
                    type: 'article-stub',
                    text: 'Drive growth—at scale',
                    href: '/customer-stories/fellow',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/b11de6045680c6b971d4b7ebeda65d16.png',
                    description: 'How Fellow onboards wholesale customers 4x faster',
                    altText: 'Close-up of a person sitting at a desk in front of an open laptop and looking off to the side at a document. Natural light is streaming through the windows in the background.',
                },
            ],
        },
        {
            text: 'Resources & Support',
            href: null,
            submenu: [
                {
                    text: 'By role',
                    href: null,
                    icon: { selected: 'fileGuide', unselected: 'fileGuideFill' },
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/resources/marketing',
                        },
                        {
                            text: 'Business owners',
                            href: '/resources/business-owner',
                        },
                        {
                            text: 'IT',
                            href: '/resources/it',
                        },
                        {
                            text: 'Sales operations',
                            href: '/resources/sales',
                        },
                    ],
                },
                {
                    text: 'Learn more',
                    href: null,
                    icon: { selected: 'miscLearn', unselected: 'miscLearn' },
                    submenu: [
                        {
                            text: 'Blog',
                            href: '/blog/',
                        },
                        {
                            text: 'Zapier Learn',
                            href: 'https://learn.zapier.com',
                        },
                        {
                            text: 'Events and webinars',
                            href: '/resources/events',
                        },
                        {
                            text: 'Customer stories',
                            href: '/customer-stories',
                        },
                        {
                            text: 'Zapier guides',
                            href: '/resources/guides',
                        },
                    ],
                },
                {
                    text: 'Get help',
                    href: null,
                    icon: { selected: 'navHelp', unselected: 'navHelp' },
                    submenu: [
                        {
                            text: 'Help Center',
                            href: '/help',
                        },
                        {
                            text: 'Community',
                            href: 'https://community.zapier.com/',
                        },
                        {
                            text: 'Hire an Expert',
                            href: '/experts',
                        },
                        {
                            text: 'Support Services',
                            href: '/l/support-services',
                        },
                        {
                            text: 'Contact Support',
                            href: '/get-help',
                        },
                    ],
                },
            ],
            bottomLinks: [
                {
                    text: 'Contact Sales',
                    icon: { selected: 'actionCalendar', unselected: 'actionCalendar' },
                    href: '/l/contact-sales?demo_source=cs_nav_menu_resources',
                },
                {
                    text: 'Explore app integrations',
                    icon: { selected: 'actionExplore', unselected: 'actionExplore' },
                    href: '/apps',
                },
                {
                    text: 'Access AI features',
                    icon: 'miscAI',
                    href: '/ai',
                },
            ],
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Zapier quick-start guide',
                    href: '/learn/zapier-quick-start-guide',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/8d754b5e8481fdd190dd7b1cf7738a8d.png',
                    description: 'Create your first Zap with ease',
                    altText: "A simplified user interface design representing a portion of Zapier's platform. There's a vertical menu of platform options. At the top is a dominant orange button with text inside that reads \"Create Zap.\" Beneath the button is a stack of menu icons to represent Zapier's dashboard and zaps.",
                },
                {
                    type: 'link-list',
                    text: 'Developer resources',
                    href: null,
                    links: [
                        {
                            text: 'Build an integration',
                            href: '/platform/how-to-build',
                        },
                        {
                            text: 'Documentation',
                            href: 'https://platform.zapier.com/docs/zapier-intro',
                        },
                        {
                            text: 'Embedded integrations',
                            href: '/partner/solutions',
                        },
                        {
                            text: 'Integration Partner Program',
                            href: '/platform/partner-program',
                        },
                    ],
                },
            ],
        },
        {
            text: 'Teams & Companies',
            href: '/teams-companies',
        },
        {
            text: 'Pricing',
            href: '/pricing',
        },
    ],
    callToAction: {
        href: `https://${process.env.ZAPIER_DOMAIN}/l/contact-sales`,
        text: 'Contact Sales',
    },
};
//# sourceMappingURL=links.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
